import {FormGroup, Label, Modal} from "reactstrap";
import React, {useState} from "react";
import {AvField, AvForm} from "availity-reactstrap-validation";
import {Alert, Checkbox, Select} from "antd";
import {connect} from "react-redux";
import {addTranslation} from "../../store/translations/actions";

const {Option} = Select
const AddTranslation = ({isNewTranslationModalOpen, onCancel, addTranslation}) => {

  const [service, setService] = useState({key: '', translations: {en: '', bg: ''}, active: false})
  const [error, setError] = useState({type: '', message: ''})

  const handleChange = ({target}) => {
    const {name, lang, value} = target
    if (name && lang) {
      service[name][lang] = value
      if (lang === 'en') {
        service.key = value.toLowerCase().trim().replace(/\W+/g, '_')
      }
    } else {
      service[name] = value
    }
    setService(prevState => ({...prevState, ...service}))
  }
  const submitForm = (e) => {
    e.preventDefault()
    const {key, typeOfService, translations} = service
    if(!key || !typeOfService || !translations.en || !translations.bg) {
      setError({type: 'error', message: 'Моля, попълни всички задължителни полета!'})
      setTimeout(() => {
        setError({type: '', message: ''})
      }, 5000)
      return
    }
    addTranslation(service)
    onCancel()
  }
  return <Modal isOpen={isNewTranslationModalOpen} toggle={onCancel}>
    <Alert {...error} style={{position: "fixed", top: '5px', right: '5px', width: 'auto'}}/>
    <div className="modal-header">
      <h5 className="modal-title mt-0">Добавяне на превод на услуга</h5>
      <button
        type="button"
        onClick={onCancel}
        className="close"
        data-dismiss="modal"
        aria-label="Затвори"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div className="modal-body">
      <AvForm className="needs-validation row">
        <FormGroup className="col-ms-12 col-md-6">
          <Label htmlFor="validationCustom01">Ключ* </Label>
          <AvField
            disabled
            name="key"
            placeholder="Ключ"
            type="text"
            style={{backgroundColor: '#D3D3D3'}}
            errorMessage="Моля, въведи ключ"
            className="form-control"
            value={service.key}
            validate={{required: {value: true}}}
            id="validationCustom01"
          />
        </FormGroup>
        <FormGroup className="col-ms-12 col-md-6">
          <Label htmlFor="validationCustom01">Тип услуга* </Label>
          <Select
            placeholder="Избери тип услуга"
            style={{width: '100%'}}
            errorMessage="Моля, избери тип услуга"
            validate={{required: {value: true}}}
            onChange={(value) => handleChange({target: {name: 'typeOfService', value}})}
            value={service?.typeOfService}
          >
            <Option value="normal">Стандартна</Option>
            <Option value="grooming">Груминг</Option>
            <Option value="hotel">Хотел</Option>
            <Option value="pet_sitter">Гледане на любимци</Option>
            <Option value="pet_walker">Разходка на кучета</Option>
          </Select>
        </FormGroup>
        <FormGroup className="col-ms-12 col-md-6">
          <Label htmlFor="validationCustom01">Превод на английски*</Label>
          <AvField
            name="translations.en"
            placeholder="Превод на английски"
            type="text"
            errorMessage="Моля, въведи превод на английски"
            className="form-control"
            onChange={(e) => handleChange({target: {name: 'translations', lang: 'en', value: e.target.value}})}
            value={service?.translations?.en}
            validate={{required: {value: true}}}
            id="validationCustom01"
          />
        </FormGroup>
        <FormGroup className="col-ms-12 col-md-6">
          <Label htmlFor="validationCustom01">Превод на български*</Label>
          <AvField
            name="translations.bg"
            placeholder="Превод на български"
            type="text"
            errorMessage="Моля, въведи превод на български"
            className="form-control"
            onChange={(e) => handleChange({target: {name: 'translations', lang: 'bg', value: e.target.value}})}
            value={service?.translations?.bg}
            validate={{required: {value: true}}}
            id="validationCustom01"
          />
        </FormGroup>
        <FormGroup className="col-ms-12 col-md-6">
          <Checkbox name='active' onChange={(e) => handleChange({
            target: {
              name: e.target.name,
              value: e.target.checked
            }
          })}>Активна</Checkbox>
        </FormGroup>
      </AvForm>
      <div className="d-flex align-items-center justify-content-end">
        <button
          type="button"
          className="btn btn-success waves-effect waves-light"
          onClick={submitForm}
        >
          Запази
        </button>
      </div>
    </div>
  </Modal>
}
const mapStateToProps = () => {
  return {}
}
export default connect( mapStateToProps, {addTranslation})(AddTranslation);
